import { PostOwnershipEnum, PostTypeEnum } from './post.constant';
import { PrivacyTypeEnum } from './privacy.constant';

export interface IMenuAction {
    id: string;
    label: string;
    icon: string;
    textColor?: string;
    showFor: PostOwnershipEnum;
    postTypes?: PostTypeEnum[];
    privacyTypes?: PrivacyTypeEnum[];
    excludeTypes?: PostTypeEnum[];
    routerLink?: string | string[];
}

export const MENU_ACTIONS: IMenuAction[] = [
    {
        id: 'edit',
        label: 'Edit Post',
        icon: '/assets/images/shared/edit-icon.svg',
        showFor: PostOwnershipEnum.OWN,
        excludeTypes: [PostTypeEnum.Post],
    },
    {
        id: 'mark-answered',
        label: 'Mark as Answered',
        icon: '/assets/images/shared/tick-grey-icon.svg',
        showFor: PostOwnershipEnum.OWN,
        postTypes: [PostTypeEnum.Prayer],
    },
    {
        id: 'save',
        label: 'Save Post',
        icon: '/assets/images/shared/save-grey-icon.svg',
        showFor: PostOwnershipEnum.ALL,
    },
    {
        id: 'share',
        label: 'Share post',
        icon: '/assets/images/shared/share-icon.svg',
        showFor: PostOwnershipEnum.ALL,
    },
    {
        id: 'pin',
        label: 'Pin post to top',
        icon: '/assets/images/shared/pin-grey-icon.svg',
        showFor: PostOwnershipEnum.ALL,
        postTypes: [PostTypeEnum.Group, PostTypeEnum.Announcement],
    },
    {
        id: 'unpin',
        label: 'Unpin from top',
        icon: '/assets/images/shared/pin-grey-icon.svg',
        showFor: PostOwnershipEnum.ALL,
        postTypes: [PostTypeEnum.Group, PostTypeEnum.Announcement],
    },
    {
        id: 'delete',
        label: 'Delete Post',
        icon: '/assets/images/shared/delete-red-icon.svg',
        textColor: '#D4183D',
        showFor: PostOwnershipEnum.OWN,
        excludeTypes: [PostTypeEnum.Post],
    },
    {
        id: 'reply',
        label: 'Reply',
        icon: '/assets/images/shared/comment-grey-icon.svg',
        showFor: PostOwnershipEnum.COMMUNITY,
        postTypes: [PostTypeEnum.Group],
    },
    {
        id: 'quote',
        label: 'Quote post',
        icon: '/assets/images/shared/quote-grey-icon.svg',
        showFor: PostOwnershipEnum.COMMUNITY,
        excludeTypes: [PostTypeEnum.Group],
    },
    {
        id: 'hide',
        label: 'Hide Post',
        icon: '/assets/images/shared/hide-grey-icon.svg',
        showFor: PostOwnershipEnum.COMMUNITY,
        privacyTypes: [PrivacyTypeEnum.Anonymous],
    },
    {
        id: 'report',
        label: 'Report post',
        icon: '/assets/images/shared/report-grey-icon.svg',
        textColor: '#D4183D',
        showFor: PostOwnershipEnum.COMMUNITY,
    },
    {
        id: 'block',
        label: 'Block User',
        icon: '/assets/images/shared/block-user-grey-icon.svg',
        textColor: '#D4183D',
        showFor: PostOwnershipEnum.COMMUNITY,
        excludeTypes: [PostTypeEnum.Anonymous],
    },
];
